{
  "title": "Comprehend Languages",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level divination (ritual)",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a pinch of soot and salt)",
  "duration": "1 hour",
  "description": [
    "For the duration, you understand the literal meaning of any spoken language that you hear. You also understand any written language that you see, but you must be touching the surface on which the words are written. It takes about 1 minute to read one page of text.",
    "This spell doesn’t decode secret messages in a text or glyph, such as an arcane sigil, that isn’t part of a written language."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
